// @catalog F.030
// FStat — Helper compacto label+value usado dentro de cards del drawer
// (tab Resumen, tab Sistema). Equivalente al .fstat del prototipo.

import { Box, Stack, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import type { ReactNode } from "react";

interface FStatProps {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  help?: string;
  /** Marca el valor en color negativo (alertas, margen <0). */
  negative?: boolean;
  /** Marca el valor con color muted (info técnica de soporte). */
  muted?: boolean;
}

export function FStat({
  label,
  value,
  sub,
  help,
  negative,
  muted,
}: FStatProps) {
  const valueColor = negative
    ? "var(--neg)"
    : muted
      ? "var(--ink-3)"
      : "var(--ink-1)";
  return (
    <Stack spacing={0.25}>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Typography
          sx={{
            fontSize: 11.5,
            color: "var(--ink-3)",
            fontWeight: 500,
            letterSpacing: "0.005em",
          }}
        >
          {label}
        </Typography>
        {help && (
          <Tooltip title={help} arrow placement="top">
            <Box
              component="span"
              sx={{
                width: 14,
                height: 14,
                borderRadius: "50%",
                bgcolor: "var(--bg-2)",
                color: "var(--ink-3)",
                display: "inline-grid",
                placeItems: "center",
                cursor: "help",
                fontSize: 9,
                "&:hover": {
                  bgcolor: "var(--accent-soft)",
                  color: "var(--accent)",
                },
              }}
              aria-label={`Información: ${label}`}
            >
              <InfoOutlinedIcon sx={{ fontSize: 10 }} />
            </Box>
          </Tooltip>
        )}
      </Stack>
      <Typography
        sx={{
          fontSize: 15,
          fontWeight: 600,
          fontVariantNumeric: "tabular-nums",
          letterSpacing: "-0.01em",
          color: valueColor,
          lineHeight: 1.3,
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {value}
      </Typography>
      {sub != null && (
        <Typography
          sx={{
            fontSize: 11.5,
            color: "var(--ink-3)",
            fontWeight: 500,
          }}
        >
          {sub}
        </Typography>
      )}
    </Stack>
  );
}

export default FStat;
